import { UseData } from '.'

type Props = Pick<UseData, 'setOpen'>

export function useHandlers(props: Props) {
  const { setOpen } = props

  function handleClick(e) {
    e.preventDefault()
    setOpen()
  }

  return { handleClick } as const
}
